import { Component, OnInit } from '@angular/core';
import { PlatformService } from '../platform.service';

@Component({
  selector: 'app-ebi-footer',
  templateUrl: './ebi-footer.component.html',
  styleUrl: './ebi-footer.component.scss',
  standalone: false
})

export class EbiFooterComponent implements OnInit {

  showBanner = false;
  constructor(private platform: PlatformService) {}

  ngOnInit(): void {
    if (this.platform.isBrowserPlatform()) {
      const agreed = this.getCookie('dataProtectionAgreed');
      this.showBanner = !agreed;
    }  
  }

  closeDataProtectionBanner(): void {
    if (this.platform.isBrowserPlatform()) {
      this.setCookie('dataProtectionAgreed', 'true', 365);
      this.showBanner = false;
    }
  }

  private getCookie(name: string): string | null {
    if (this.platform.isBrowserPlatform()) {
      const platformdocument = this.platform.getDocument();
      const match = platformdocument.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }
  }

  private setCookie(name: string, value: string, days: number): void {
    if (this.platform.isBrowserPlatform()) {
      const platformdocument = this.platform.getDocument();
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      platformdocument.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    }
  }
}